// types
import { StatsEngagement } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Chip, ChipProps, Tooltip } from '@mui/material';

// utils
import { formatPercentage } from '../../../utils/format';

// props
export interface ChipParticipationProps {
	entities?: StatsEngagement['entities'];
	users?: StatsEngagement['users'];
}

export const ChipParticipation = ({ entities, users }: ChipParticipationProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	let color: ChipProps['color'] = 'default';

	let participation = 0;
	let title;
	let total = 0;

	if (entities) {
		participation = entities.participation;
		total = entities.active.length + entities.inactive.length;
		title = t('xOfYActiveEntities', { x: entities.active.length, y: total });
	} else if (users) {
		participation = users.participation;
		total = users.active.length + users.inactive.length;
		title = t('xOfYActiveUsers', { x: users.active.length, y: total });
	}

	if (participation) {
		if (participation >= 75) {
			color = 'success';
		} else if (participation >= 50) {
			color = 'warning';
		} else if (participation > 0) {
			color = 'error';
		}
	}

	const chip = (
		<Chip color={color} label={formatPercentage(participation)} size="small" variant="twoTone" />
	);

	return (
		<Tooltip arrow={true} title={title} placement="top">
			{chip}
		</Tooltip>
	);
};
